import { Component, ViewChild, ElementRef, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { OrdersService } from '../../_services/orders.service';
import { ServerConn } from '../../_services/serverConn.service';
import { TWADialogsService } from '../../_services/twa-dialogs.service';

interface DialogData {
    idpedido: number;
}

@Component({
    selector: 'app-order-viewer',
    templateUrl: './order-viewer.component.html',
    styleUrls: ['./order-viewer.component.css'],
    standalone: false
})
export class OrderViewerComponent implements OnInit, AfterViewInit {

    pdfSrc: string;
    idpedido: number;

    @ViewChild('pdfViewer')
    pdfViewer: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<OrderViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private ordersSvc: OrdersService,
        private server: ServerConn,
        private dlgsSvc: TWADialogsService
    ) {
      console.log('🚀 ~ file: order-viewer.component.ts ~ line 29 ~ OrderViewerComponent ~ constructor ~ data', data);
      this.idpedido = data.idpedido;
      console.log('🚀 ~ file: order-viewer.component.ts ~ line 29 ~ OrderViewerComponent ~ constructor ~ data', this.idpedido);
      this.pdfSrc = this.server.serverUrl + 'orders/pdf?r=' + this.idpedido + '&api_key=' + localStorage.getItem('api_key');

    }

    ngOnInit() {
      console.log('🚀 ~ file: order-viewer.component.ts ~ line 29 ~ OrderViewerComponent ~ ngOnInit ~ this.idpedido', this.idpedido);
      this.ordersSvc.getById(this.idpedido).subscribe((res: any) => {
        console.log('🚀 ~ file: order-viewer.component.ts ~ line 30 ~ OrderViewerComponent ~ this.ordersSvc.getById ~ res', res);
      });
    }

    ngAfterViewInit() {
    }

    updateViewer() {
      this.pdfViewer.nativeElement.querySelector('.ng2-pdf-viewer-container').style.position = 'relative';
    }

    openPdf() {
      window.open(this.pdfSrc, '_blank');
    }

    downloadPdf() {
      window.open(this.pdfSrc + '&d=1', '_blank');
    }

    close() {
      this.dialogRef.close();
    }

}